import _ from "lodash";

const getFileByExtension = (files, extension) =>
  _.find(files, (file) => _.last(file.name.split(".")) === extension);

export default getFileByExtension;
